import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const AdminGuard = (): Observable<boolean> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isAdmin().pipe(
    take(1), // Prend une seule valeur de l'observable
    map(isAdmin => {
      console.log('Admin détecté ?', isAdmin); // 🔍 Debug
      if (!isAdmin) {
        console.log('Redirection vers /admin/login'); // 🔍 Debug
        router.navigate(['/admin/login']);
      }
      return isAdmin;
    })
  );
};

